import React from "react";
import SvgIcon from "./SvgIcon";

function BackArrowButton({
  onBack,
  text = "Back",
  hidden = false,
  classNames = "",
}) {
  return (
    <button
      data-button-type="tertiary"
      data-icon-only=""
      onClick={onBack}
      className={classNames}
      type="button"
    >
      <SvgIcon src="/img/new-icons/arrow-square-left.svg" />
    </button>
  );
}

export default BackArrowButton;
